import React, { Component } from "react";
import { render } from "react-dom";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { createRoot } from "react-dom/client";


import SearchTickersHeaderComponent from "../pages/search-tickers-header-component";

import axios from "axios";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/users/workspace/" element={<SearchTickersHeaderComponent />} />
      </Routes>
    </Router>
  );
}

const container = document.getElementById("react-search-tickers-root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App tab="home" />);
